import { useState } from 'react';
import api from 'service/api';
import { useAuth } from '../auth';

export const useBookPresence = () => {
  const { requestIntercept } = useAuth();

  const [loading, setLoading] = useState(false);

  const getJoinedStringScales = (scales) => {
    let joinedStringScales = scales
      .map((item) => item.value)
      .join('&scale_id=');
    return (joinedStringScales =
      scales.length > 0 ? `scale_id=${joinedStringScales}` : '');
  };

  const getAgendaPdf = async (params, scales) =>
    new Promise((resolve, reject) => {
      (async function () {
        try {
          setLoading(true);

          const requestUrl = `/v1/agendas/pdf?${getJoinedStringScales(
            scales
          )}&empty=${params.empty}&unit_id=${params.unit_id}${
            params.subsidiary_id ? `&subsidiary_id=${params.subsidiary_id}` : ''
          }&year=${params.year}&month=${params.month}&report_checkin=${
            params.report_checkin
          }&pdf_model=${params.pdf_model}&hide_reduced_work=${
            params.hide_reduced_work
          }`;

          // Uma única requisição: baixa o PDF como blob e dispara o download
          // direto, sem segundo GET via window.open.
          const response = await requestIntercept(api.get, requestUrl, null, {
            responseType: 'blob',
          });

          if (!response || response.status !== 200) throw response?.data;

          const blob = new Blob([response.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `caderno-de-presenca-${params.year}-${params.month}.pdf`
          );
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          setLoading(false);
          resolve('success');
        } catch (error) {
          setLoading(false);
          reject('Nenhuma agenda encontrada neste período!');
        }
      })();
    });

  return {
    loading,
    getAgendaPdf,
  };
};
